/*
#*===================================================================
#*
#* Licensed Materials - Property of Zuum Transportation Inc.
#*
#* Copyright Zuum 2015-2022. All Rights Reserved.
#*
#*===================================================================
*/

import { createAction, props } from '@ngrx/store';
import { ActivityLog } from '@core/models';
import { AcitivityLogType } from '@core/enums';

export const loadActivityLogs = createAction(
  '[ClientDetails:Activity Log] Load Activity Logs',
  props<{ clientId: number }>()
);
export const loadActivityLogsSuccess = createAction(
  '[ClientDetails:Activity Log] Load Activity Logs Success',
  props<{ activityLogs: ActivityLog[] }>()
);
export const loadActivityLogsFailure = createAction(
  '[ClientDetails:Activity Log] Load Activity Logs Failure',
  props<{ errorMessage: string }>()
);

export const createActivityLog = createAction(
  '[ClientDetails] Create Activity Log',
  props<{ clientId: number; oldValue: any; newValue: any; activityLogType: AcitivityLogType; subType: string }>()
);
export const createActivityLogSuccess = createAction(
  '[ClientDetails] Create Activity Log Success',
  props<{ activityLog: ActivityLog }>()
);
export const createActivityLogFailure = createAction(
  '[ClientDetails] Create Activity Log Failure',
  props<{ errorMessage: string }>()
);
